import type { TextField } from '@payloadcms/plugin-form-builder/types'
import type { Control, FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import React from 'react'
import { Controller } from 'react-hook-form'
import { formatPhoneNumber } from '@/utils/formatPhoneNumber'

import { Error } from '../Error'
import { Width } from '../Width'

export const Phone: React.FC<
  TextField & {
    errors: Partial<FieldErrorsImpl>
    register: UseFormRegister<FieldValues>
    control: Control<FieldValues>
  }
> = ({ name, defaultValue, errors, label, control, required, width }) => {
  return (
    <Width width={width}>
      <Label htmlFor={name} className="sr-only">
        {label}

        {required && (
          <span className="required">
            * <span className="sr-only">(required)</span>
          </span>
        )}
      </Label>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue || ''}
        rules={{
          required,
          pattern: {
            value: /^\(\d{3}\) \d{3}-\d{4}$/, // Validate full mask
            message: 'Please enter a valid phone number',
          },
        }}
        render={({ field: { onChange, value, ...field } }) => (
          <Input
            {...field}
            className="input-site"
            id={name}
            type="tel"
            value={value}
            onChange={(e) => {
              // Handle backspace properly?
              // Simple replacement handles most cases for typing forward.
              // Backspacing might be tricky if we don't allow raw input, but let's try standard mask
              const formatted = formatPhoneNumber(e.target.value)
              // Limit to execution length
              if (formatted.length <= 14) {
                onChange(formatted)
              }
            }}
            placeholder={label}
          />
        )}
      />
      {errors[name] && <Error name={name} />}
    </Width>
  )
}
